import script from "./CoreProgramQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreProgramQuestions.vue?vue&type=script&setup=true&lang=js"

import "./CoreProgramQuestions.vue?vue&type=style&index=0&id=6a8a0940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a8a0940"]])

export default __exports__